module.exports = __webpack_public_path__ + "static/media/zh-Hans.4641acc3.svg";